"use client";

import { Button } from "@/components/ui/button";
export default function TeamSection() {
  return <section id="teamsection" className="bg-background py-16 px-4 !h-[900px] sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {}
        <h1 className="font-display font-bold text-foreground text-center !text-5xl ![margin:-30px_0px_50px_0px]">Leadership Is The Most Powerful Resource</h1>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-12 items-center">
          <div className="order-2 lg:order-1">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_munno3hj.png" alt="Creative Director" className="w-full h-auto rounded-lg shadow-medium" />
          </div>
          <div className="order-1 lg:order-2 space-y-4">
            <h2 className="font-display text-white !text-4xl !text-center">According to a Hay Group Study</h2>
            <p className="text-white leading-relaxed mt-12 !text-center !text-[26px]">"Leaders had up to a 70% influence on the climate &amp; culture of the company, creating a 28% difference in the bottom line."</p>
            
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12">
          <div className="space-y-4">
            <h2 className="font-display text-white !w-[700px] !text-3xl !text-left">Research in Harvard Business Review article “Maximizing Your Return On People” found:</h2>
            <p className="text-white leading-relaxed !text-center ![margin:50px_0px_0px_0px] !text-[26px]">“Companies with higher scores for their investment in human capital delivered stock returns that <br />were five times higher than companies <br />with less emphasis.”</p>
            
          </div>
          <div>
            <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/up-arrow-scaled.jpg" alt="Lead Developer" className="w-full h-auto rounded-lg shadow-medium" />
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12">
          <div>
            
          </div>
          <div className="space-y-4">
            
            
          </div>
        </div>
      </div>
    </section>;
}